import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {useSelector} from "react-redux";
import {countMembership, message} from "../../api/app";
import generateChar from "../../utils/generateChar";
import formatNumber from "../../utils/formatNumber";

let searchableFields = [
    { field: 'text', isNumeric: false },
    { field: 'name', isNumeric: false }
]

const Message = () => {

    document.title = "Message";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const {province, districts, constituencies, wards, polling_stations} = useSelector(state => state.app?.administrative);

    useEffect(() => {
        let table = $('#message_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Message Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "Message",
                        searchableFields,
                        filter: {},
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.subject;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.sender_id
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY")
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return "No Action"
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_company"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        $('#message_table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            if(d.raw.type === "quick") {
                return (
                    '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td>Message:</td>' +
                    '<td>' +
                    d?.raw.text +
                    '</table>'
                );
            }

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Message:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.text +
                '<tr>' +
                '<td>Total Members:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.metadata.totalMembers +
                '<tr class="text-primary">' +
                '<td>Valid Number:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.metadata.valid +
                '<tr class="text-success">' +
                '<td>Sent:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.metadata.sent +
                '<tr class="text-danger">' +
                '<td>Failed:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.metadata.failed +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const initialize = () => {
        // Province
        $('#province').select2({
            placeholder: 'Select Provinces',
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        // Other dropdowns
        $('#district, #constituency, #ward, #polling_station').select2({
            placeholder: 'Select...',
            multiple: true,
            width: '100%'
        });

        // Province → District
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredDistricts = districts.filter(d =>
                selectedProvinces.includes(d.administrative)
            );

            $('#district').empty().select2({
                placeholder: 'Select Districts',
                multiple: true,
                width: '100%',
                data: filteredDistricts.map(d => ({
                    id: d._id,
                    text: capitalize(d.name)
                }))
            }).val(null).trigger('change');

            $('#constituency, #ward, #polling_station')
                .val(null).trigger('change').empty();
        });

        // District → Constituency
        $('#district').on('change', function () {
            const selectedDistricts = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedDistricts.includes(c.district)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');

            $('#ward, #polling_station')
                .val(null).trigger('change').empty();
        });

        // Constituency → Ward
        $('#constituency').on('change', function () {
            const selectedConstituencies = $(this).val() || [];
            const filteredWards = wards.filter(w =>
                selectedConstituencies.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(null).trigger('change');

            $('#polling_station').val(null).trigger('change').empty();
        });

        // Ward → Polling Station
        $('#ward').on('change', function () {
            const selectedWards = $(this).val() || [];
            const filteredPollings = polling_stations.filter(p =>
                selectedWards.includes(p.ward)
            );

            $('#polling_station').empty().select2({
                placeholder: 'Select Polling Stations',
                multiple: true,
                width: '100%',
                data: filteredPollings.map(p => ({
                    id: p._id,
                    text: capitalize(p.name)
                }))
            }).val(null).trigger('change');
        });
    }

    const handleShowModal = () => {
        $('#message_bulk_form').parsley();
        initialize();
        $("#modalBulkMessage").modal("show");
    }

    const handleQuickMsgShowModal = () => {
        $('#message_quick_form').parsley();
        $('#recipient').select2({
            placeholder: 'Enter Recipient',
            multiple: true,
            tags: true,
            tokenSeparators: [',', ' '],
            width: '100%'
        });
        $("#modalQuickMessage").modal("show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    }

    const handleBulkSMSSubmit = (e) => {
        e.preventDefault();
        let sender_id = $('#sender-id').val() || $("#sender-id-1").val();
        let subject = $('#subject').val() || $("#subject-1").val();
        let text_message = $('#message').val() || $("#message-1").val();
        let source = $('#data-source').val();
        let provincial = $('#province').val();
        let district = $('#district').val();
        let constituency = $('#constituency').val();
        let ward = $('#ward').val();
        let polling = $('#polling_station').val();

        setStateReady(true);

        let data = {
            sender_id,
            subject,
            type: "bulk",
            message: text_message,
            admin_level: []
        };

        if(source) {
            Object.assign(data, {source});
        }

        if(provincial.length > 0) {
            data.admin_level.push({
                model: "administrative",
                data: provincial
            });
        }

        if(district.length > 0) {
            data.admin_level.push({
                model: "district",
                data: district
            });
        }

        if(constituency.length > 0) {
            data.admin_level.push({
                model: "constituency",
                data: constituency
            });
        }

        if(ward.length > 0) {
            data.admin_level.push({
                model: "ward",
                data: ward
            });
        }

        if(polling.length > 0) {
            data.admin_level.push({
                model: "polling",
                data: polling
            });
        }

        message(data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Message successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalBulkMessage", "message_bulk_form");
                reloadTable();
            }
        });
    }

    const handleQuickMessageSubmit = (e) => {
        e.preventDefault();

        let sender_id = $('#sender-id').val() || $("#sender-id-1").val();
        let subject = $('#subject').val() || $("#subject-1").val();
        let text_message = $('#message').val() || $("#message-1").val();
        let recipient = $('#recipient').val();

        setStateReady(true);

        let data = {
            sender_id,
            subject,
            type: "quick",
            message: text_message,
            recipient
        };

        message(data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Message successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalQuickMessage", "message_quick_form");
                reloadTable();
            }
        });
    }

    const handleCountMember = (e) => {
        let source = $('#data-source').val();
        let provincial = $('#province').val();
        let district = $('#district').val();
        let constituency = $('#constituency').val();
        let ward = $('#ward').val();
        let polling = $('#polling_station').val();

        let {hide} = cogoToast.loading('Please wait... contacting to server.', {position: "top-right", hideAfter: 5});

        let data = {
            admin_level: []
        };

        if(source) {
            Object.assign(data, {source});
        }

        if(provincial.length > 0) {
            data.admin_level.push({
                model: "administrative",
                data: provincial
            });
        }

        if(district.length > 0) {
            data.admin_level.push({
                model: "district",
                data: district
            });
        }

        if(constituency.length > 0) {
            data.admin_level.push({
                model: "constituency",
                data: constituency
            });
        }

        if(ward.length > 0) {
            data.admin_level.push({
                model: "ward",
                data: ward
            });
        }

        if(polling.length > 0) {
            data.admin_level.push({
                model: "polling",
                data: polling
            });
        }

        countMembership(data).then((result) => {
            hide();
            if(!result.error) {
                cogoToast.success(`Total Count: ${formatNumber(result.payload)}`, {position: "top-right", hideAfter: 5});
            }
        });
    }

    const reloadTable = () => {
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Messages</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Messages</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5 outline-none" onClick={handleQuickMsgShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Quick Message</button>
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Bulk SMS</button>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Message</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => reloadTable()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="message_table" className="table" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-25p">Subject</th>
                                        <th className="wd-25p">Sender ID</th>
                                        <th className="wd-25p">Date</th>
                                        <th className="wd-25p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalBulkMessage" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalBulkMessage", "message_bulk_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Bulk Message</h4><p className="tx-13 tx-color-02 mg-b-0">Send bulk message to the membership</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="message_bulk_form" className="parsley-style-1" onSubmit={handleBulkSMSSubmit.bind()}>
                                    <div id="roleWrapper" className="form-group parsley-input">
                                        <label>Data Source (Optional)</label>
                                        <select className="custom-select" id="data-source">
                                            <option value="" disabled selected>Select Source</option>
                                            <option value="kwenyu">Kwenyu</option>
                                            <option value="c4w">C4W</option>
                                            <option value="health">Health</option>
                                            <option value="sct">Social Cash Transfer</option>
                                            <option value="fisp">FISP</option>
                                            <option value="napsa">NAPSA</option>
                                        </select>
                                    </div>

                                    <div id="provinceWrapper" className="form-group parsley-input">
                                        <label>Province</label>
                                        <select id="province"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#provinceWrapper"
                                                data-parsley-errors-container="#provinceWrapper"
                                                className="custom-select"
                                        >
                                        </select>
                                    </div>

                                    <div id="districtWrapper" className="form-group parsley-input">
                                        <label>District</label>
                                        <select id="district"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#districtWrapper"
                                                data-parsley-errors-container="#districtWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="constituencyWrapper" className="form-group parsley-input">
                                        <label>Constituency</label>
                                        <select id="constituency"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#constituencyWrapper"
                                                data-parsley-errors-container="#constituencyWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="wardWrapper" className="form-group parsley-input">
                                        <label>Ward</label>
                                        <select id="ward"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#wardWrapper"
                                                data-parsley-errors-container="#wardWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="pollingStationWrapper" className="form-group parsley-input">
                                        <label>Polling Station</label>
                                        <select id="polling_station"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#pollingStationWrapper"
                                                data-parsley-errors-container="#pollingStationWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="senderWrapper" className="form-group parsley-input">
                                        <label>Sender ID</label>
                                        <select className="custom-select" id="sender-id">
                                            <option value="" disabled selected>Select Source</option>
                                            <option value="Imisepela">Imisepela</option>
                                            <option value="Hakainde">Hakainde</option>
                                            <option value="Kwenyu">Kwenyu</option>
                                        </select>
                                    </div>

                                    <div id="subjectWrapper" className="form-group parsley-input">
                                        <label>Subject<span className="tx-danger">*</span></label>
                                        <input id="subject" type="text" className="form-control"
                                               placeholder="Enter subject"
                                               autoComplete="off"
                                               data-parsley-class-handler="#subjectWrapper" required/>
                                    </div>

                                    <div id="messageWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Message<span className="tx-danger">*</span></label>
                                            <a href="javascript:void(0)" onClick={() => handleCountMember()} className="link-01 tx-primary">Count Total</a>
                                        </div>
                                        <textarea
                                            id="message"
                                            className="form-control"
                                            rows="8"
                                            data-parsley-class-handler="#messageWrapper"
                                            data-parsley-validation-threshold="10"
                                            placeholder="Enter Message..."
                                            maxLength="150"
                                            required
                                        ></textarea>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Send Message</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalQuickMessage" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalQuickMessage", "message_quick_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Quick Message</h4><p className="tx-13 tx-color-02 mg-b-0">Send quick message to the recipient</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="message_quick_form" className="parsley-style-1" onSubmit={handleQuickMessageSubmit.bind()}>
                                    <div id="senderWrapper" className="form-group parsley-input">
                                        <label>Sender ID</label>
                                        <select className="custom-select" id="sender-id-1">
                                            <option value="" disabled selected>Select Source</option>
                                            <option value="Bally">Bally</option>
                                            <option value="Kwenyu">Kwenyu</option>
                                        </select>
                                    </div>

                                    <div id="recipientWrapper" className="form-group parsley-input">
                                        <label>Recipient<span className="tx-danger">*</span></label>
                                        <select id="recipient"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#recipientWrapper"
                                                data-parsley-errors-container="#recipientWrapper"
                                                className="custom-select"
                                                required
                                        >
                                        </select>
                                    </div>

                                    <div id="subjectWrapper" className="form-group parsley-input">
                                        <label>Subject<span className="tx-danger">*</span></label>
                                        <input id="subject-1" type="text" className="form-control"
                                               placeholder="Enter subject"
                                               autoComplete="off"
                                               data-parsley-class-handler="#subjectWrapper" required/>
                                    </div>

                                    <div id="messageWrapper" className="form-group parsley-input">
                                        <label>Message<span className="tx-danger">*</span></label>
                                        <textarea
                                            id="message-1"
                                            className="form-control"
                                            rows="8"
                                            maxLength="150"
                                            data-parsley-class-handler="#messageWrapper"
                                            data-parsley-validation-threshold="10"
                                            placeholder="Enter Message..."
                                            required>
                                        </textarea>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Send Message</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Message;
